import { ChannelType, channelTypeInfo } from "../models/ChannelType";
import GroupAddress from "../models/GroupAdress";
import { itx } from "../translationItx/itx";
import AddressGeneratorUtils, { getGaFromCollection } from "./AddressGeneratorUtils";
import { createButtonAddresses_3 } from "./createButtonAddresses";
import generateAddressesForConsumer_3 from "./generateAddressesForConsumer_3";

// Impementiert folgendes Schema:
//
//  Gewerk / Etage / Type - Funktion
//
// Gewerk:
//    0 - Schalter
//    1 - Dimmen
//    2 - Heizen
//    5 - Rolladen
//    7 - Gruppen (Tasten & Multiplexer)
//

export function createAddresses_C() {
  for (const type of [
    ChannelType.Switch,
    ChannelType.Dimmer,
    ChannelType.Heating,
    ChannelType.TuneableWhite,
    ChannelType.Blind,
    ChannelType.Jalousie,
    "Tasten", // no itx
  ]) {
    const addr = AddressGeneratorUtils.getAddressForChannelTypeLevel1(type);

    let mainGroup = getGaFromCollection(state.addresses, (a) => a.address == addr.toString());
    if (!mainGroup) {
      let name = itx(`channelType.${type}`, type);
      if (type == ChannelType.Switch) {
        name += " / " + itx(`channelType.${ChannelType.Lock}`, ChannelType.Lock);
      }

      mainGroup = GroupAddress.createNewGroupAddress({
        level: 1,
        name: name,
        address: addr,
        parent: state.addresses,
      });
    }

    state.floors.sortBy("tagOrName").forEach((floor) => {
      const floorName = `${floor.tag} ${floor.name}`;

      let middleGroup = getGaFromCollection(mainGroup.children, (a) => a.name == floorName);

      if (!middleGroup) {
        middleGroup = GroupAddress.createNewGroupAddress({
          level: 2,
          name: floorName,
          parent: mainGroup,
        });
      }

      floor
        .allConsumers()
        .filter((c) => !channelTypeInfo(c.channelType).isSupply)
        .forEach((consumer) => {
          let match = consumer.channelType == type;
          if (type == ChannelType.Switch) {
            match ||= consumer.channelType == ChannelType.Lock;
          }
          if (match) {
            generateAddressesForConsumer_3(consumer, middleGroup);
          }
        });

      if (type == "Tasten") {
        floor.rooms.sortBy("tag").forEach((room) => {
          room.buttons.sortBy("tagOrName").forEach((button) => {
            createButtonAddresses_3(button, middleGroup);
          });
        });
      }
    });
  }
}
